'use client'
import React from 'react'

interface TableBottomControls extends React.HTMLAttributes<HTMLDivElement> {
    children: JSX.Element
}

export const TableBottomControls = ({ children, ...props }: TableBottomControls): JSX.Element => {
    return (
        <div className="table-bottom-controls border border-border-default h-14 flex" {...props}>
            {children}
        </div>
    )
}
